export default __webpack_public_path__ + "static/media/instagram.72f08f87.png";